module.exports = __webpack_public_path__ + "img/IMG_8155_L_Foamcore.bc639314.jpg";